import { render } from "./Archive.vue?vue&type=template&id=134b2452&scoped=true"
import script from "./Archive.js?vue&type=script&lang=js"
export * from "./Archive.js?vue&type=script&lang=js"

import "./Archive.vue?vue&type=style&index=0&id=134b2452&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134b2452"]])

export default __exports__